import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const breedsStartRequest = () => {
  return {
    type: 'BREEDS_START_REQUEST'
  };
};

export const breedsEndRequest = () => {
  return {
    type: 'BREEDS_END_REQUEST'
  };
};

export const getAllBreedsSuccess = ({ data }) => {
  return {
    type: 'BREEDS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllBreedsError = error => {
  return {
    type: 'BREEDS_GET_ALL_ERROR',
    payload: error
  };
};

export const addBreedsSuccess = ({ data }) => {
  return {
    type: 'BREEDS_ADD_SUCCESS',
    payload: data
  };
};

export const addBreedsError = error => {
  return {
    type: 'BREEDS_ADD_ERROR',
    payload: error
  };
};

export const editBreedsSuccess = ({ data }) => {
  return {
    type: 'BREEDS_EDIT_SUCCESS',
    payload: data
  };
};

export const editBreedsError = error => {
  return {
    type: 'BREEDS_EDIT_ERROR',
    payload: error
  };
};

export const removeBreedsSuccess = id => {
  return {
    type: 'BREEDS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeBreedsError = error => {
  return {
    type: 'BREEDS_REMOVE_ERROR',
    payload: error
  };
};

export const breedsModifyStore = ({ data }) => {
  return {
    type: 'BREEDS_MODIFY_STORE',
    payload: data
  };
};

export const addBreeds = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(breedsStartRequest());
      const response = await api().post('/api/breeds', data);
      dispatch(addBreedsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'breeds',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addBreedsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(breedsEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllBreeds = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(breedsStartRequest());
      const response = await api().get('/api/breeds', { params });
      dispatch(getAllBreedsSuccess(response));
    } catch (err) {
      dispatch(getAllBreedsError(err));
    } finally {
      dispatch(breedsEndRequest());
    }
  };
};

export const editBreeds = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(breedsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(breedsStartRequest());
      const id = data._id;
      const response = await api().put('/api/breeds/' + id, data);
      dispatch(editBreedsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'breeds',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/breeds'));
      }
    } catch (err) {
      dispatch(editBreedsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeBreeds = id => {
  return async dispatch => {
    try {
      dispatch(breedsStartRequest());
      await api().delete('/api/breeds/' + id);
      dispatch(removeBreedsSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'breeds',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Raça removida com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeBreedsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover raça.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(breedsEndRequest());
    }
  };
};

export const restoreBreeds = data => {
  return async dispatch => {
    try {
      dispatch(breedsStartRequest());
      const id = data._id;
      const response = await api().put('/api/breeds/' + id, data);
      dispatch(editBreedsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'breeds',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Raça restaurada com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editBreedsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar raça.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(breedsEndRequest());
    }
  };
};
